<script lang="ts" setup>
    import { ref, useSlots, onMounted, computed } from 'vue';
    import { useIntersectionObserver, } from '@vueuse/core';

    let slots = useSlots();
    let bottom = ref<HTMLElement | null>(null);

    let slottedContent = computed(() => {
        return slots.default ? slots.default() : [];
    });

    let maxItemsToShow = ref(20)
    let virtualContent = computed(() => {
        return slottedContent.value.slice(0, maxItemsToShow.value);
    });
    onMounted(() => {

        let { stop } = useIntersectionObserver(bottom, ([{ isIntersecting }]) => {
            if(maxItemsToShow.value < slottedContent.value.length){
                maxItemsToShow.value = Math.min((maxItemsToShow.value + 20), slottedContent.value.length);
            }

            if(maxItemsToShow.value == slottedContent.value.length){
                stop();
            }

        }, {
            threshold: 0,
        });
    });
</script>

<template>
    <div>
        <component :is="content" v-for="(content, index) of virtualContent" :key="content.key ?? index"/>

        <div ref="bottom"></div>
    </div>
</template>
